module.exports = __webpack_public_path__ + "static/media/camera.8a4fe463.svg";